<template>
  <div id="not-found">
    <div class="mdc-drawer-scrim"></div>

    <div id="app-content" class="mdc-drawer-app-content flex-auto overflow-auto relative">
      <TopAppBar />
      <NavDrawer />
      <Header />
      <Main />
      <p id="notfound">Not found</p>
      <Footer />
    </div>
  </div>
</template>

<script>
import TopAppBar from "@/components/header/TopAppBar.vue";
import NavDrawer from "@/components/header/NavDrawer.vue";
import Main from "@/components/body/Main.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "NotFound",
  components: {
    TopAppBar,
    NavDrawer,
    Main,
    Header,
    Footer,
  },
  mounted() {
  },
};
</script>

<style>
#notfound {
  margin: 4.25rem 1.75rem 1rem;
}
</style>
